import React from 'react';
import BrowseTilesHeader from '../BrowseTiles/BrowseTilesHeader';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';

const PageNotFoundTitleHeader = () => {
  const { localized } = useUrlBuilder();
  return (
    <BrowseTilesHeader title="PAGE NOT FOUND">
      Unfortunately, we can't seem to find the page you're looking for. Click the images below to continue discovering
      italist's luxury fashion offerings, or browse our{' '}
      <a style={{ textDecoration: 'underline' }} href={localized()}>
        homepage
      </a>
      .
    </BrowseTilesHeader>
  );
};

export default PageNotFoundTitleHeader;
